import React, { useContext, useState } from 'react'
import './Navbar.css'
import logo from '../Assets/logo.png'
import cartIcon from '../Assets/cart_icon.png'
import { Link } from 'react-router-dom'
import { ShopContext } from '../../Context/ShopContext'
const Navbar = () => {
    const [menu,setMenu]=useState("Shop")
    const { getTotalCartItems}=useContext(ShopContext)
  return (
    <div className='navbar'>
        <div className="nav-logo">
            <img src={logo} alt="" srcset="" />
            <p>SHOPPERS</p>
        </div>
        <ul className='nav-menu'>
            <li onClick={()=>{setMenu("shop")}}><Link style={{ textDecoration: 'none' }} to='/'>Shop</Link>{menu==="shop"?<hr/>:null}</li>
            <li onClick={()=>{setMenu("Mens")}}><Link style={{ textDecoration: 'none' }} to='/mens'>Men</Link>{menu==="Mens"?<hr/>:null}</li>
            <li onClick={()=>{setMenu("Womens")}}><Link style={{ textDecoration: 'none' }} to='/womens'>Women</Link>{menu==="Womens"?<hr/>:null}</li>
            <li onClick={()=>{setMenu("Kids")}}><Link style={{ textDecoration: 'none' }} to='/kids'>Kids</Link>{menu==="Kids"?<hr/>:null}</li>

        </ul>
        <div className="nav-login-cart">
            <Link style={{ textDecoration: 'none' }} to='/login'> <button>Login</button></Link>
            <Link style={{ textDecoration: 'none' }} to='/cart'><img src={cartIcon} alt="" />
            </Link>
            <div className='nav-cart-count'>
                {getTotalCartItems()}

            </div>
        </div>
      
    </div>
  )
}

export default Navbar
